import 'iview/dist/styles/iview.css';
import './styles/element-variables.scss';
import '@/styles/element-ui.scss';
import '@/styles/reset.scss';
import 'view-design/dist/styles/iview.css';
import './permisson.js';

import Vue from 'vue';

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import fabric from 'fabric';
import moment from 'moment';
import ViewUI from 'view-design';
import VueKonva from 'vue-konva';
import VueMatomo from 'vue-matomo';

import App from './App.vue';
import router from './router';
import store from './store';
import http from './utils/http';

Vue.prototype.$moment = moment

Vue.use(fabric);
Vue.use(ViewUI);

Vue.use(VueKonva);

// 图片异步加载
Vue.directive('async-src', {
  bind: function (el, binding) {
    el.setAttribute('src', 'placeholder.jpg')
    binding.value().then((src) => {
      Vue.nextTick(() => {
        el.setAttribute('src', src)
      })
    })
  }
})

Vue.use(VueMatomo, {


  host: 'https://stat.prosuntech.com', // 这里配置你自己的piwik服务器地址和网站ID

  siteId: 3,//siteId值

  // 根据router自动注册

  router: router,

  // // 是否需要在发送追踪信息之前请求许可

  // // 默认false

  requireConsent: false,

  enableLinkTracking: true,

  // // 是否追踪初始页面

  // // 默认true

  trackInitialView: false,

  // // 最终的追踪js文件名

  // // 默认 'piwik'

  trackerFileName: 'matomo',

  debug: false

});

Vue.config.productionTip = false
// 全局过滤器
import * as filters from '@/filter'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.prototype.$http = http
Vue.use(ElementUI, { locale })
Date.prototype.Format = function (fmt) {
  var o = {
    "y+": this.getFullYear(),
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S+": this.getMilliseconds() //毫秒
  };
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      if (k == "y+") {
        fmt = fmt.replace(
          RegExp.$1,
          ("" + o[k]).substr(4 - RegExp.$1.length)
        );
      } else if (k == "S+") {
        var lens = RegExp.$1.length;
        lens = lens == 1 ? 3 : lens;
        fmt = fmt.replace(
          RegExp.$1,
          ("00" + o[k]).substr(("" + o[k]).length - 1, lens)
        );
      } else {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
  }
  return fmt;
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
